import styled, { css } from 'styled-components'
import { ButtonUnstyled } from '@sketch/components'
import { ReactComponent as Expand } from '@sketch/icons/rectangle-diagonal-arrow-up-left-17'
import { ReactComponent as Rectangles } from '@sketch/icons/rectangles-2-17'
import { ReactComponent as DotsBlur } from '@sketch/icons/dots-blur-11'
import { ReactComponent as Circle } from '@sketch/icons/circle-11'
import checkerboardBackground from '@sketch/icons/inspector/checkboard-background.svg'

export const ExpandIcon = styled(Expand)`
  flex: none;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  position: absolute;
  right: 16px;
  top: 12px;
  display: none;
  cursor: pointer;
`

export const HoverContainer = styled.div<{
  visible?: boolean
}>(
  ({ theme, visible }) => css`
    cursor: pointer;
    width: calc(100% + 25px);
    min-height: 31px;
    position: relative;
    display: flex;
    align-items: center;
    background-color: ${visible ? theme.colors.state.hover : undefined};
    border-radius: ${theme.radii.large};

    margin-bottom: 4px;
    margin-left: -12px;
    padding-left: 12px;
    margin-right: -12px;
    padding-right: 12px;

    ${visible &&
    css`
      ${ExpandIcon} {
        display: block;
      }
    `}

    &:hover {
      background-color: ${theme.colors.state.hover};
      ${ExpandIcon} {
        display: block;
      }
    }

    &:active {
      background-color: ${theme.colors.background.tertiary.B};
      ${ExpandIcon} {
        display: block;
      }
    }
  `
)

export const SwatchContainer = styled.div`
  margin: 16px 0;
  width: 300px;
  height: 148px;
  position: relative;
  background-image: url(${checkerboardBackground});
  background-size: 8px;
  box-shadow: 0 -1px 0 0 inset;
  box-shadow:
    0 -1px 0 0 inset ${({ theme }) => theme.colors.border.A},
    0 1px 0 0 inset ${({ theme }) => theme.colors.border.A};
`

export const iconStyles = css`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const CopyIcon = styled(Rectangles)`
  ${iconStyles}
`

export const CopyButton = styled(ButtonUnstyled)`
  ${iconStyles}
`

export const FormatDetail = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const StopContainer = styled.div<{ connected: boolean }>`
  display: flex;
  position: relative;
  align-items: center;

  ${({ connected, theme }) =>
    connected &&
    css`
      padding-bottom: 16px;

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 22px;
        left: 51px;
        margin: auto;
        width: 1px;
        height: 8px;
        background-color: ${theme.colors.border.A};
      }
    `}
`

const textStyle = css`
  font-size: 0.8125rem;
  text-align: right;
`

export const StopText = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  min-width: 34px;
  ${textStyle}
`

export const StopValue = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  margin-right: 4px;
  ${textStyle}
`

const blurIconStyles = css`
  width: 11px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  margin: 0 12px;
`

export const DotsBlurIcon = styled(DotsBlur)`
  ${blurIconStyles}
`

export const CircleIcon = styled(Circle)`
  ${blurIconStyles}
`
